import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=65868304&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style1 from "./Transactions.vue?vue&type=style&index=1&id=65868304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65868304",
  null
  
)

export default component.exports